import Vue from 'vue';
import components from './app/components';
import {ToastPlugin} from 'bootstrap-vue/src';
import {ModalPlugin} from 'bootstrap-vue/src';
import VueCurrencyInput from 'vue-currency-input';
import Container from '@services/Container';
import VueFactory from '@services/VueFactory';
import VueCompositionAPI from '@vue/composition-api'
import DesktopRoutes from '@desktop/app/routes';
import * as VueGoogleMaps from 'gmap-vue';

const container = Container.getInstance();
const authRepository = container.getAuthRepository();

// Allow other (older jQuery/Zend/rent) code to add functions to be called after Vue init because Vue replaces the DOM.
window.vueInitQueue = [];

Vue.use(ToastPlugin);
Vue.use(VueCompositionAPI);
Vue.use(ModalPlugin);
Vue.use(VueCurrencyInput);

for (let componentsKey in components) {
    Vue.component(componentsKey, components[componentsKey]);
}

function initUserOptionsToggle() {
  const userOptions = document.querySelector('#header .user-options');
    if (!userOptions) return;

  document.body.addEventListener('click', function handleUserOptionsClick(event) {
    const overlay = userOptions.querySelector('.overlay-container');
    if (!overlay) return;

    const clickedInsideOverlay = overlay.contains(event.target);
    const clickedInsideUserOptions = userOptions.contains(event.target);

    if (clickedInsideOverlay) return;

    if (clickedInsideUserOptions) {
      userOptions.classList.add('active');
    } else {
      userOptions.classList.remove('active');
    }
  });
}

function highlightNavLinks() {
    const tabsRef = document.getElementById('tabs');
    if (!tabsRef) {
        return
    }
    const navLinks = tabsRef.querySelectorAll('.nav-link');
    const currentURL = window.location.href;
    navLinks.forEach(link => {
        const linkHref = link.getAttribute('href');
        if (!linkHref) return;
        const linkUrl = new URL(linkHref, window.location.origin).href;
        if (currentURL.includes(linkUrl)) {
            link.classList.add('active', 'router-link-active');
        } else {
            link.classList.remove('active');
        }
    });
}

jQuery(() => {
    const container = Container.getInstance();
    const errorHandler = container.getErrorHandler()
    errorHandler.silenceForbiddenErrors()
    errorHandler.initialize();
    container.getLoadingState().initialize();
    container.getTranslationRepository().loadTranslation().then((result) => {
        const attributes = result.data.attributes;
        i18n.setLocaleMessage(attributes.locale, attributes.messages);
        i18n.locale = attributes.locale;
        container.getEventBus().emit('translations-loaded');
    });

    /** @see e.g. in csp/application/modules/damage/views/scripts/record/summary.phtml */
    const rawContextData = document.getElementById('vue-context-data')?.textContent
    const vueContextData = rawContextData ? JSON.parse(rawContextData) : {}

    const vueFactory = new VueFactory({
        el: '#layout',
        data: {
            contextData: vueContextData,
            loadingState: container.getLoadingState().state,
            multiselectOptionHeight: 32,
            signState: container.getSignRepository().state,
            translationKeySuffix: ' desktop',
            useLegacyPdfViewer: null,
        },
    });
    vueFactory.usePlugin(
        VueGoogleMaps,
        {
            load: {
                key: 'AIzaSyDb3STd2hlZKqCODtzXI5BEB9hver1wEYw',
                libraries: 'places, geometry', // Necessary for places input
            },
            installComponents: true,
        }
    );

    if (window.location.pathname.includes('/Mobilitaets-Manager/')) {
        window.moduleName = 'rent';
    } else {
        window.moduleName = 'damage';
    }

    vueFactory.useRouter(DesktopRoutes, {mode: 'history'});
    const i18n = vueFactory.initializeI18n();
    container.getTranslator().setVueI18n(i18n);

    authRepository.getUserInfo().then(
        (data) => {
            container.getLoginStatusStore().setCurrentUser(data);
        },
        () => {
            container.getLoginStatusStore().clearState();
            this.hasLoginStatusError = true;
        }
    ).finally(() => {
        window.cspVueMain = vueFactory.createVue();
        initUserOptionsToggle();
        highlightNavLinks();
        window.highlightNavLinks = highlightNavLinks;
        if (Array.isArray(window.vueInitQueue)) {
            window.vueInitQueue.forEach(fn => {
                try {
                    fn();
                } catch (e) {
                    console.error('Error executing vueInitQueue item:', e);
                }
            });
            window.vueInitQueue = [];
        }
    });
});
